import { render, staticRenderFns } from "./GSGnGEMAContent.vue?vue&type=template&id=d86f7e94&scoped=true"
import script from "./GSGnGEMAContent.vue?vue&type=script&lang=js"
export * from "./GSGnGEMAContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86f7e94",
  null
  
)

export default component.exports